import { ContentTypes, requestToCMS } from './requestToCMS';
import { Endpoint, getStrapiEndpoint } from '../../constants';

/**
 * Configuration for the post request made to the CMS.
 */
type PostConfig = {
    /*
     The endpoint to make the request to
     */
    endpoint: Endpoint;
    /*
     The data that should send to the backend. It can either be a json string or
     a FormData object.
     */
    body: FormData | string;
    /*
    Content type of the body. If not defined application/json is used as default
     */
    contentType?: ContentTypes;
    /*
    The token to use in the request. Either the user token for logged in/user specific actions or our API token for general requests.
     */
    jwt: string;
};

const postToCMS = async <T, E = any>({ endpoint, body, contentType, jwt }: PostConfig) => {
    const requestUrl = getStrapiEndpoint(endpoint);
    return requestToCMS<T, E>({
        url: requestUrl,
        method: 'POST',
        accessToken: jwt,
        body,
        contentType
    });
};

export { postToCMS };
